import { render, staticRenderFns } from "./ProdutoModal.vue?vue&type=template&id=3b331056&scoped=true"
import script from "./ProdutoModal.vue?vue&type=script&lang=js"
export * from "./ProdutoModal.vue?vue&type=script&lang=js"
import style0 from "./ProdutoModal.vue?vue&type=style&index=0&id=3b331056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b331056",
  null
  
)

export default component.exports